module.exports = __webpack_public_path__ + "static/media/rounded-add-button.90f8f537.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/rounded-add-button.svg
// module id = 1209
// module chunks = 0